import React from 'react';
import Link from '../../base/Link/Link';

const IconButton = ({ icon, link, width }) => {
  return (
    <Link href={link}>
      <img src={icon} style={{ width: width || '20px' }} loading="lazy" />
    </Link>
  );
};

export default IconButton;
